import { ReportColor } from '@/types/transmissionReport';
import { DeviceLeadLocation } from '@/types/vendorTransmissionReport';

export interface MonitoredValuesForm {
  leadIds: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
  sensing: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
  impedance: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
  threshold: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
  pulsewidth: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
  highVoltageImpedance: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
  svcImpedance: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
  percentPaced: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
  afBurden: {
    [DeviceLeadLocation.RA]: string | null | undefined;
    [DeviceLeadLocation.RV]: string | null | undefined;
    [DeviceLeadLocation.LV]: string | null | undefined;
  };
}

export interface Lead {
  leadId: number;
  vendorId: string;
  location: DeviceLeadLocation;
  manufacturer: string;
  model: string;
  implantDate: string;
  serialNumber: string;
}

export const Sections: Record<DeviceLeadLocation, string> = {
  RA: 'Right Atrium',
  RV: 'Right Ventricle',
  LV: 'Left Ventricle'
};

export function getReportColorForBadge(color: ReportColor): string {
  const colorMap: Record<ReportColor, string> = {
    [ReportColor.Red]: 'red',
    [ReportColor.Yellow]: 'yellow',
    [ReportColor.Green]: 'green',
    [ReportColor.Gray]: 'gray',
    [ReportColor.ReviewPending]: 'primary'
  };
  return colorMap[color] || 'primary';
}

export function getUnderReviewDisplayName(
  user: { given?: string; family?: string } | null | undefined
): string {
  if (!user) return 'another user';
  const given = (user.given ?? '').trim();
  const family = (user.family ?? '').trim();
  const name = [given, family].filter(Boolean).join(' ');
  return name || 'another user';
}
